import * as React from 'react';
import { UitkCard, UitkCardImageLayout } from 'uitk-react-cards';
import { DestinationRefinementImage } from './destination-refinement-image';
import { DestinationRefinementLink } from './destination-refinement-link';
import { PwaHsrPropertyDestinationRefinement } from 'src/common/__generated__/api';
import { DestinationRefinementCardContent } from './destination-refinement-card-content';

export interface DestinationRefinementCardProps {
  destination: PwaHsrPropertyDestinationRefinement.Destinations;
  position: number;
  showAffinities?: boolean;
  showDescription?: boolean;
}

export const DestinationRefinementCard: React.FunctionComponent<DestinationRefinementCardProps> = ({
  position,
  showDescription,
  showAffinities,
  destination: { id, searchUrl, name, description, affinities, attributedImage }
}) => {
  const attribution = attributedImage && attributedImage.attribution;
  const image = attributedImage && attributedImage.image;

  return (
    <UitkCard imageLayout={UitkCardImageLayout.LEFT_FULLBLEED}>
      {image && image.url && <DestinationRefinementImage {...{ image }} />}
      <DestinationRefinementCardContent {...{ name, description, affinities, attribution, showAffinities, showDescription }} />
      <DestinationRefinementLink {...{ id, position, searchUrl, name }} />
    </UitkCard>
  );
};
